// Hand-curated Google reviews for GYMPODS Dalston and Putney.
// To refresh: paste new review text + author into the appropriate `items` array,
// update `averageRating` and `reviewCount` to match the Google Business profile,
// and commit. No API, no build step, no Elfsight.

export const REVIEWS = {
  dalston: {
    placeUrl:
      'https://www.google.com/maps/search/?api=1&query=GYMPODS+Dalston',
    averageRating: 5.0,
    reviewCount: 146,
    // Display override for the Google review count. The numeric
    // `reviewCount` stays accurate for JSON-LD / aggregateRating; the
    // visible label rounds DOWN to the nearest tens marker so the
    // claim never inflates relative to the actual count (Google's
    // review-snippet guideline: visible content must not deceive).
    googleCountLabel: '100+',
    platforms: [
      {
        name: 'Wellhub',
        rating: 4.95,
        countLabel: '30+ reviews',
        url: 'https://wellhub.com/en-uk/search/partners/4a6b48cd-adc8-4b1c-950f-75bbe47ec9b1/',
      },
      {
        name: 'Classpass',
        rating: 4.9,
        countLabel: '5,000+ reviews',
        url: 'https://classpass.com/studios/gympods-london',
      },
    ],
    items: [
      {
        id: 'dalston-001',
        author: 'Poppy',
        rating: 5,
        date: '2025-08-01',
        text: 'The staff are SO nice and welcoming. I love coming here and the concept has made me feel much more confident!',
      },
      {
        id: 'dalston-003',
        author: 'Solomon B.',
        rating: 5,
        date: '2025-04-01',
        text: 'Great concept. Good facilities, decent equipment, and really friendly staff.',
      },
      {
        id: 'dalston-004',
        author: 'Jordan K.',
        rating: 5,
        date: '2025-04-01',
        text: "Came here to train with a friend while out in London and it was amazing! Really easy to book a pod online, we did it while on the train into London. We even arrived earlier than the booking time and were able to move our booked time to an earlier one which was really useful. We booked a Strength pod and were really impressed with the space itself and equipment. Really clean, private space with everything you could need for a workout. The individual shower/changing rooms were also great and really handy, plus really well maintained. Being able to hire a towel for only £1.50 each was also really convenient as it saved us needing to bring our own. The woman working on reception and the co-founder who was in reception were both really friendly and helpful while greeting us and showing us round. For what you get and the quality of the equipment, it's really well priced. Would definitely come back here to train in future!",
      },
      {
        id: 'dalston-005',
        author: 'Kevin L.',
        rating: 5,
        date: '2025-04-01',
        text: "Really lovely staff and fantastic facilities. This is a great gym for anyone that wants to train on their own or with a friend in a private space. Highly recommend! It's also in a great location - right by the station!",
      },
      {
        id: 'dalston-006',
        author: 'Luba',
        rating: 5,
        date: '2025-04-01',
        text: 'This gym is fab! Great equipment both in the pods and outside for you to use. Clean changing rooms and showers. Easy to book via classpass. Staff were helpful when I made a booking error.',
      },
      {
        id: 'dalston-007',
        author: 'Lisa',
        rating: 5,
        date: '2025-04-01',
        text: "I first came across this gym on Instagram ads and thought to myself 'omg this gym is the solution of my problem'. I started with the starter pack 6 credits for £15, each pod per hour requires 3 credits. I immediately fell in love with this gym. I subscribed monthly after the starter pack and never been so excited to go to the gym. The staffs are very nice too, theres no awkward vibe and straightforward process.",
      },
      {
        id: 'dalston-008',
        author: 'D Shorties',
        rating: 5,
        date: '2024-04-01',
        text: "Superb gym! I've been a member for two months and I can't fault a single thing. So convenient and well equipped. It's well run and the team are always so friendly/helpful. Game changer! Big thanks!",
      },
      {
        id: 'dalston-009',
        author: 'C Wood',
        rating: 5,
        date: '2024-04-01',
        text: "As a self-professed gym-phobe in my mid-forties, stumbling into Gympods near my Dalston abode was less about a fitness epiphany and more about finding a place where I could awkwardly exercise in peace. With their monthly membership, I've managed to negotiate a truce with my conscience, attending five days a week at a cost that barely tickles the wallet. The charm of Gympods lies not just in its convenient location or the private pods that shield me from the judgement of more enthusiastic gym-goers. It's in the subtle nod of acknowledgment from the staff, who have mastered the art of encouragement without the need for any of that excessive, motivational cheerleading. In summary, for those of you in Dalston or nearby looking for a place to maintain your fitness regime with a dignified level of personal denial, Gympods is your spot. It's not so much a gym as it is a haven for those of us who view exercise as a necessary evil rather than a lifestyle.",
      },
      {
        id: 'dalston-010',
        author: 'Shi',
        rating: 5,
        date: '2024-04-01',
        text: 'Fantastic idea - absolutely love this. Definitely saves me money and I love the fact I get my own space!',
      },
      {
        id: 'dalston-011',
        author: 'Lyann',
        rating: 5,
        date: '2024-04-01',
        text: "Super clean, well equipped, easy to book, great location and super friendly staff. Had my first session in the STRENGTH pod and it was by far the best gym experience I've ever had. Made me like going to the gym again!",
      },
      {
        id: 'dalston-012',
        author: 'Mark',
        rating: 5,
        date: '2024-04-01',
        text: "I recently joined GYMPODS and have had an outstanding experience from day one. The owners, Mike and Simon, are not only experienced professionals but also lovely, down-to-earth people who genuinely care about their members. Mike went above and beyond to assist me in applying as an Instructor at the gym, and the turnaround time was impressively fast. The staff at GYMPODS are fantastic, creating a welcoming and supportive atmosphere that sets the gym apart. It's evident that they are committed to providing a positive and inclusive environment for all members. The gym itself is well-equipped, with spacious pods that offer a private and focused workout experience. The added convenience of showers and toilets is a definite plus. The overall cleanliness and maintenance of the facility are top-notch, reflecting the dedication of the management to providing a comfortable and hygienic space. One of the standout features of GYMPODS is the genuine atmosphere it exudes. It's not just a place to work out; it feels like a community.",
      },
      {
        id: 'dalston-013',
        author: 'May',
        rating: 5,
        date: '2024-04-01',
        text: 'I have been using gym pods since May and have lost nearly 40kg just being given that private space to work on myself really helped my self esteem and confidence! Not to mention the top tier equipment and amazing team! The space is always clean and tidy especially the changing and shower facilities! 100% worth the money! Whether it\'s for personal or religious reasons that a mainstream gym are not for you this gym is perfect for private and peaceful workouts!',
      },
      {
        id: 'dalston-014',
        author: 'Samuel C.',
        rating: 5,
        date: '2024-04-01',
        text: "I've been using GymPods for over a year and loved every session. Having a space to yourself is game changing. The staff are always lovely and welcoming, the owners are very personable, the facilities are spotlessly clean and there is always availability. Would highly recommend.",
      },
      {
        id: 'dalston-015',
        author: 'Lorena M.',
        rating: 5,
        date: '2024-04-01',
        text: 'Love the space, the equipment, privacy and friendly staff.',
      },
      {
        id: 'dalston-016',
        author: 'Barbara F.',
        rating: 5,
        date: '2024-04-01',
        text: 'Absolutely incredible place, every pod is fully equipped, clean and spacious! Lovely staff, highly recommend!',
      },
      {
        id: 'dalston-017',
        author: 'Kate D.',
        rating: 5,
        date: '2024-04-01',
        text: 'My favourite gym in London. The spaces are always super clean and the staff/owners are lovely. The pods have everything you need so you will never need to go to a commercial gym again.',
      },
      {
        id: 'dalston-018',
        author: 'James W.',
        rating: 5,
        date: '2024-04-01',
        text: 'Gympods are great — staff are friendly and knowledgable, the facilities are always clean, plenty of equipment to use and always slots when I need them. I always enjoy my workouts here and would recommend it to anyone.',
      },
      {
        id: 'dalston-019',
        author: 'James P.',
        rating: 5,
        date: '2024-04-01',
        text: 'Great facilities and nice people - good for those that want to work on specific improvements away from classes or crowded gym floors.',
      },
      {
        id: 'dalston-020',
        author: 'Glenn H.',
        rating: 5,
        date: '2024-04-01',
        text: 'GymPods is an excellent gym. I was initially sceptical about the concept but after trying a one-off session I signed up to the subscription. The pods have the highest quality equipment and enables a full workout just like a full gym, without the wait for equipment becoming available. Great staff who are always seeking ways to improve.',
      },
      {
        id: 'dalston-021',
        author: 'Emily C.',
        rating: 5,
        date: '2024-04-01',
        text: 'A fantastic gym with large private spaces to work out. Each pod is spotless and has everything you need. Really friendly staff. Would definitely recommend to try it out!',
      },
      {
        id: 'dalston-022',
        author: 'B T.',
        rating: 5,
        date: '2024-04-01',
        text: 'Really lovely staff at the front desk, really clean facilities and quiet. Highly recommend if you want to workout in peace and have all the equipment to yourself! Went with my friend and it was a lot more productive than a general gym sesh!',
      },
      {
        id: 'dalston-024',
        author: 'Adam C.',
        rating: 5,
        date: '2024-04-01',
        text: 'Friendly, private and well equipped. Like having your own gym!',
      },
      {
        id: 'dalston-025',
        author: 'Richard E.',
        rating: 5,
        date: '2026-05-28',
        text: 'Terrific space — modern equipment and never feels crowded. Great snacks and lovely staff too!',
      },
      {
        id: 'dalston-026',
        author: 'Nicole R.',
        rating: 5,
        date: '2026-05-27',
        text: "Best gym in area, maybe even in London? But if I'm honest, I don't want you to know about it so I resent writing this 5 star review. Total privacy, all the equipment you need, lovely staff and owners. Stay away, it's mine!",
      },
      {
        id: 'dalston-027',
        author: 'Ollie W.',
        rating: 5,
        date: '2026-05-27',
        text: 'Never used to go to the gym, now I go all the time! Staff are super helpful and friendly.',
      },
      {
        id: 'dalston-028',
        author: 'Oliver M.',
        rating: 5,
        date: '2026-05-07',
        text: 'Great equipment, clean, well run. I train with a PT over FaceTime and this is the perfect way to do it without annoying other gymgoers.',
      },
      {
        id: 'dalston-029',
        author: 'Ailbhe H.',
        rating: 5,
        date: '2026-05-27',
        text: 'Staff are all super lovely, and the pods are well equipped. No complaints!!',
      },
    ],
  },
  putney: {
    placeUrl:
      'https://www.google.com/maps/search/?api=1&query=GYMPODS+Putney',
    averageRating: 4.9,
    reviewCount: 48,
    // Display override for the Google review count. The numeric
    // `reviewCount` stays accurate for JSON-LD / aggregateRating; the
    // visible label rounds DOWN to the nearest tens marker so the
    // claim never inflates relative to the actual count (Google's
    // review-snippet guideline: visible content must not deceive).
    googleCountLabel: '70+',
    platforms: [
      {
        name: 'Wellhub',
        rating: 5.0,
        countLabel: '20+ reviews',
        url: 'https://wellhub.com/en-uk/search/partners/gympods-putney/',
      },
      {
        name: 'Classpass',
        rating: 4.9,
        countLabel: '500+ reviews',
        url: 'https://classpass.com/studios/gympods-putney-london-eayk',
      },
    ],
    items: [
      {
        id: 'putney-001',
        author: 'Tom D.',
        rating: 5,
        date: '2026-03-01',
        text: "I live near Fulham and had been looking for a private gym near me for ages. Everything locally was either packed or just felt overwhelming. GYMPODS Putney has been a game changer. Having your own private gym pod means no waiting for equipment and no distractions, which has honestly helped me stay far more consistent with training. I work in Wandsworth, so I often pop in on my way home. It's so easy to book on the app and just show up - once it's in the diary, I'm far more accountable. I also found a brilliant personal trainer via the GYMPODS website, and training with them in a private gym setting has helped me massively. On Wednesdays you can bring a friend for free as well, so I've brought along a colleague a few times which has been great. If you're in Putney, Fulham or Wandsworth and want a private gym where you can properly focus and get your session done, I'd definitely recommend it.",
      },
      {
        id: 'putney-002',
        author: 'Dane S.',
        rating: 5,
        date: '2026-02-01',
        text: "Tried GymPods Putney for the first time this morning and I'm seriously impressed. The whole place feels incredibly exclusive in the best way. It's private, calm and clearly designed for people who just want to get in and train properly without the usual gym chaos. The facilities are immaculate. Everything is brand new, clean and really well looked after. You can tell a lot of thought (and capital) has gone into the setup and overall experience. The staff were excellent. Very welcoming, friendly and helpful, which made the first visit easy and comfortable. I'd highly recommend GymPods to anyone looking for a more private, premium training environment. A great alternative to crowded commercial gyms. I'll definitely be back!",
      },
      {
        id: 'putney-003',
        author: 'Cat S.',
        rating: 5,
        date: '2026-01-01',
        text: "Best gym in Putney! Very friendly staff and the whole concept is great. I also feel it's reasonably priced, you get credits which you can use on what you want when you want!",
      },
      {
        id: 'putney-004',
        author: 'Eloïse E.',
        rating: 5,
        date: '2025-11-01',
        text: "Simply AMAZING! I cannot recommend this enough. The facilities are clean spacious, fully equipped. And the best part, it's your own space! Such a brilliant idea. It's everything I've dreamed of in a gym, best workout in years. I will keep coming back.",
      },
      {
        id: 'putney-005',
        author: 'Emma K.',
        rating: 5,
        date: '2026-02-01',
        text: 'Such a welcome change from the classic gym - being able to easily use all high quality equipment without having to wait is a huge time saver!',
      },
      {
        id: 'putney-006',
        author: 'AJ',
        rating: 5,
        date: '2026-03-01',
        text: 'GymPod Putney is unreal. Strength pod is top tier and Sophia made the whole experience even better.',
      },
      {
        id: 'putney-007',
        author: 'Lucy W.',
        rating: 5,
        date: '2026-03-01',
        text: "I'll be using GymPods for my last few weeks before moving out of London - I really appreciate how flexible this space is.",
      },
      {
        id: 'putney-008',
        author: 'Luis A.',
        rating: 5,
        date: '2026-05-27',
        text: 'Great space. Amazing service. Really convenient and super helpful staff. Thank you',
      },
      {
        id: 'putney-009',
        author: 'E.C. Louis',
        rating: 5,
        date: '2026-05-26',
        text: 'Both Mike and Simon were really kind and helpful! This is a lovely independent gym and I love the fact there are private pods. Nice energy there, nice staff. Will definitely come back',
      },
      {
        id: 'putney-010',
        author: 'Christina A.-P.',
        rating: 5,
        date: '2026-05-22',
        text: "GYMPODS arriving in Putney has been a game changer for me. I'm using the reformer pod for my training and it's so convenient. Well equipped, calm, super easy booking system. The rest of the rooms are all brilliantly equipped, and no queues for equipment! Lovely staff too. Brilliant concept!!",
      },
      {
        id: 'putney-011',
        author: 'David K.',
        rating: 5,
        date: '2026-05-21',
        text: 'I train here 3 times a week with my PT Shannon Cunningham. The premises is 30 seconds away from East Putney station. The premium equipment is a treat. Being in such a great place helps me stay motivated since we started training again. Shannon is determined to get me in the best shape of my life at 53, and he is succeeding.',
      },
    ],
  },
};

export function combinedReviews(limit = 9) {
  return [...REVIEWS.dalston.items, ...REVIEWS.putney.items]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, limit);
}

export function combinedAverage() {
  const all = [...REVIEWS.dalston.items, ...REVIEWS.putney.items];
  const total = REVIEWS.dalston.reviewCount + REVIEWS.putney.reviewCount;
  const weighted =
    REVIEWS.dalston.averageRating * REVIEWS.dalston.reviewCount +
    REVIEWS.putney.averageRating * REVIEWS.putney.reviewCount;
  return {
    averageRating: Math.round((weighted / total) * 10) / 10,
    reviewCount: total,
    sampleCount: all.length,
  };
}
